import { CARD_NAMES, get_points_for_card, VANGUARDS } from '../../TwoD/Common/CardUtilities';

export default function artificialDraftAction(gamePlayerController, aiPackage) {
    const gamePlayer = gamePlayerController.gamePlayerData;
    const draftChoices = gamePlayerController.gameData.draft_choices;
    let cardScores = [];

    // Was `!draft_choices.length > 0` which misparses as `(!length) > 0` and
    // then did a bare (silent) return -- a silent no-emit parks the seat
    // (HSH_STYLE AI always-act). On genuinely-empty choices decline explicitly.
    if (!draftChoices || draftChoices.length === 0) {
        console.error('missing draft choices');
        aiPackage.addToMessage('No Draft choices; skip.');
        if (aiPackage.execute) {
            gamePlayerController.gamePlayerApi.clickNext();
        }
        return;
    }


    draftChoices.map((cardId, draftIndex) => {
        let cardScore = 0;
        [0, 1, 2, 3].forEach((_, dockIndex) => {
            let cardData = get_points_for_card(
                gamePlayer.station, gamePlayer.robot_assignments,
                gamePlayer.lodging, cardId, dockIndex,
                true, VANGUARDS.includes(cardId));
            if (cardData.points !== 'Danger') {
                cardScore += cardData.points;
            }
        })
        cardScores.push(cardScore);
    });
    let choiceIndex = (cardScores[0] > cardScores[1]) ? 0 : 1;
    // Single-choice draft: cardScores[1] is undefined, so the ternary resolves
    // to 1 and draft_choices[1] is undefined -> clickDraftChoice(undefined).
    // Clamp to a real choice index.
    if (choiceIndex >= draftChoices.length) {
        choiceIndex = draftChoices.length - 1;
    }
    let choice = draftChoices[choiceIndex];
    const cardName = CARD_NAMES[choice];
    aiPackage.success = true;
    aiPackage.addToMessage(`Draft ${cardName}`);
    aiPackage.addProvenance(
        `Is the first Card's score across all docks is greater?`,
        cardName,
        `${cardScores[0]} > ${cardScores[1]}`);
    if (aiPackage.execute) {
        gamePlayerController.gamePlayerApi.clickDraftChoice(choice);
    }
}
